import { IHeaderType } from "../../../types/types";
import SectionHeader from "../../../utils/section-header";

type Props = {};

const RowOne = (props: Props) => {

  return (
    <>
      <SectionHeader
        titleText={"Stellar Service Testimonials"}
        descText={"Hear real success stories from satisfied customers. Learn how our solutions deliver value and make a positive impact on businesses like yours. See proof of our performance in action."}
        type={IHeaderType.h2}
      />
    </>
  );
};

export default RowOne;
